import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { instructionsApi } from 'src/Services/API';

const useFetchInstruction = (instructionId?: string) => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fetch-instruction', assetId, instructionId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      if (!instructionId) throw new Error('No instructionId provided');

      return (await instructionsApi.instructionsControllerFindOne(assetId, instructionId)).data;
    },
    enabled: Boolean(assetId && instructionId),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchInstruction;
